<script>
  import { formatSignedPercent } from '../../../lib/strategyResult.js';

  // Top-N drawdown episodes: [{ peak, valley, recovery|null, depth }]. pyfolio renders this as a TABLE
  // (not a chart), so we do too. Open drawdowns (recovery === null) show "ongoing" — never an Invalid Date.
  export let data = [];

  $: rows = data || [];
  $: hasData = rows.length >= 1;

  function fmtDate(v) {
    if (!v) return '—';
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString();
  }

  // Duration in days from peak to recovery (or to valley for an open drawdown), for context.
  function durationDays(peak, end) {
    if (!peak || !end) return '—';
    const a = new Date(peak).getTime();
    const b = new Date(end).getTime();
    if (Number.isNaN(a) || Number.isNaN(b)) return '—';
    return `${Math.max(0, Math.round((b - a) / 86_400_000))}d`;
  }
</script>

<div class="bt-chart">
  <h4 class="bt-chart-title">Worst Drawdown Periods</h4>
  {#if hasData}
    <table class="bt-dd-table">
      <thead>
        <tr><th>Depth</th><th>Peak</th><th>Valley</th><th>Recovery</th><th>Duration</th></tr>
      </thead>
      <tbody>
        {#each rows as r}
          <tr>
            <td class="bt-dd-depth">{formatSignedPercent(r.depth)}</td>
            <td>{fmtDate(r.peak)}</td>
            <td>{fmtDate(r.valley)}</td>
            <td>{r.recovery ? fmtDate(r.recovery) : 'ongoing'}</td>
            <td>{durationDays(r.peak, r.recovery ?? r.valley)}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  {:else}
    <div class="empty-state"><p class="empty-state-description">No drawdown periods for this run.</p></div>
  {/if}
</div>

<style>
  /* This component renders a table (no canvas), so it inlines only the two layout rules it needs from
     charts.css rather than importing the whole sheet (whose canvas selectors would be pruned as unused). */
  .bt-chart {
    width: 100%;
    margin-bottom: var(--spacing-md);
  }
  .bt-chart-title {
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-semibold);
    color: var(--text-secondary);
    margin-bottom: var(--spacing-xs);
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
  .bt-dd-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.8rem;
  }
  .bt-dd-table th,
  .bt-dd-table td {
    padding: 0.35rem 0.5rem;
    text-align: left;
    border-bottom: 1px solid var(--border-subtle, #1e1f22);
  }
  .bt-dd-table th {
    color: var(--text-muted, #8a8b8d);
    font-weight: 500;
  }
  .bt-dd-depth {
    color: var(--loss, #ff3b3b);
    font-variant-numeric: tabular-nums;
  }
</style>
